<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import { useEditModeStore } from '@/stores/editMode'

// Global, admin-only floating toggle for in-place content editing. Rendered from AppSubnav (it is
// position:fixed, so DOM placement is cosmetic) and self-hides for non-admins, so editable regions
// on every chrome — public and admin — get the same affordance.
const { user } = storeToRefs(useAuthStore())
const editMode = useEditModeStore()
const isAdmin = computed(() => user.value?.role === 'ADMIN')
</script>

<template>
  <button
    v-if="isAdmin"
    type="button"
    class="cem-pill"
    :class="{ on: editMode.on }"
    @click="editMode.toggle()"
  >
    <span class="cem-icon">&#9998;</span>
    {{ editMode.on ? 'Editing content — done' : 'Edit content' }}
  </button>
</template>

<style scoped>
/* Flat Broadsheet slug: square corners, ink border, paper face; inverts when armed. */
.cem-pill {
  position: fixed;
  bottom: 18px;
  right: 18px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 0;
  border: 1px solid var(--ink, #0d151d);
  background: var(--paper, #f5f8fb);
  color: var(--ink, #0d151d);
  font-family: var(--font-sans, Helvetica, Arial, sans-serif);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(13, 21, 29, 0.25);
}
.cem-pill:hover {
  border-color: var(--accent, #1f6fd4);
  color: var(--accent, #1f6fd4);
}
.cem-pill.on {
  background: var(--accent, #1f6fd4);
  border-color: var(--accent, #1f6fd4);
  color: #fff;
}
.cem-icon { font-size: 13px; line-height: 1; }
</style>
